import { Router, ActivatedRoute } from '@angular/router';
import { listKeyitem } from './../../../../../shared/Models/SelectItems';
import { WorkFlowService } from './../../services/work-flow.service';
import { Component, OnInit } from '@angular/core';
import { WorkFlowBaseVm } from '../../models/workFlowVm';
import { NbToastrService, NbComponentStatus, NbDialogRef } from '@nebular/theme';

@Component({
  selector: 'ngx-work-flow-create',
  templateUrl: './create.component.html',
  styleUrls: ['./create.component.scss'],
})
export class CreateWorkFlowComponent implements OnInit {
  isEdit = false;
  data: listKeyitem[] = [];
  name: string;
  workflowVm: WorkFlowBaseVm;
  phasesSectionEnable: boolean = false;
  workFlowConfigurationEnable: boolean;
  error: boolean;
  constructor(
    private service: WorkFlowService,
    private active: ActivatedRoute,
    private route: Router,
    private toastrService: NbToastrService,
    private ref: NbDialogRef<CreateWorkFlowComponent>,   
  ) {}

  ngOnInit() {
      this.route.events.subscribe(()=>{
      this.ref.close('false');
     });
    // this.workflowVm.objectRefId = this.active.snapshot.params.id;
    // this.workflowVm.objectName = this.active.snapshot.params.name;
    //this.loadRequiredData();
    console.log(this.workflowVm);

    if (!this.isEdit) {
      this.workflowVm = {} as WorkFlowBaseVm;
      this.workflowVm.name = '';
    }
  }

  loadRequiredData() {
    this.service.getCreateNew().subscribe((resp) => {
      this.data = resp;
    });
  }
  save() {
    // this.workflowVm.name = 'test3';
    const position = 'top-right';
    if (!this.isEdit)
      this.service.post(this.workflowVm).subscribe(
        (res) => {
          this.showToast(position, 'تم إضافة سير عمل جديد بنجاح', 'success');
          this.phasesSectionEnable = true;
          this.workFlowConfigurationEnable = false;
          // const route = ['admin/workflow/phases/new/' + res];
          // this.route.navigate(route);
          this.ref.close('true');
        },
        (err) => {
          this.error = true;
        }
      );
    else {
      this.service.put(this.workflowVm.id, this.workflowVm).subscribe(
        (res) => {
          this.showToast(position, 'تم تعديل سير العمل بنجاح', 'success');
          this.ref.close('true');
        },
        (err) => {
          this.error = true;
        }
      );
    }
  }
  showToast(position, message, status: NbComponentStatus) {
    this.toastrService.show(message, '', { position, status });
  }

  closePopup() {
    this.ref.close('true');
  }
}
